export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Medium.fdb018c4.woff2";